// Each entry: `key` is the internal module key, `name` is the FROZEN
// access-grant string (stored per-user in `user_modules`, compared in
// Menu.vue, and byte-matched to the backend MODULE_NAME). `label` is an
// optional display-only override for the UI — it never touches stored data.
interface ModuleConfigItem {
  key: string
  name: string
  label?: string
}

const ModulesConfig: ModuleConfigItem[] = [
  { key: 'dashboard', name: 'Dashboard' },
  { key: 'certification', name: 'Certification' },
  { key: 'sub_certification', name: 'Sub Certification' },
  { key: 'operations', name: 'Operations' },
  { key: 'audit', name: 'Audit' },
  { key: 'manage_data', name: 'Manage Data' },
  { key: 'manage_users', name: 'Manage Users' },
  { key: 'business', name: 'Business' },
  { key: 'reports', name: 'Reports' },
  { key: 'manage_employees', name: 'Manage Employees' },
  { key: 'signature_platform', name: 'Signature Platform' },
  { key: 'finance', name: 'Finance' },
  { key: 'business_automation', name: 'Business Automation' },
  { key: 'downloads', name: 'Downloads' },
  { key: 'client_affairs', name: 'Client Affairs' },
  { key: 'external_contacts', name: 'External Contacts' },
  // `name` ('Expense Tracker') is the frozen grant string (stored per-user,
  // must byte-match backend MODULE_NAME — do NOT rename). `label` is the
  // display name shown to users; the module was rebranded to 'Financial
  // Obligations' without touching the stored grant.
  { key: 'expense_tracker', name: 'Expense Tracker', label: 'Financial Obligations' },
  // `name` is the FROZEN grant string. It is stored per-user in `user_modules`
  // and byte-matched by the backend const
  // `scholar_engagement::reports::handlers::SCHOLAR_ENGAGEMENT_REPORTS_MODULE`.
  // Renaming either side without the other silently revokes everyone's access.
  { key: 'scholar_engagement_reports', name: 'Scholar Engagement Reports' },
  // `name` is the FROZEN grant string. It is stored per-user in `user_modules`
  // and byte-matched by the backend const
  // `review_requests::handlers::MODULE_NAME`. Renaming either side without the
  // other silently revokes everyone's access.
  { key: 'review_requests', name: 'Review Requests' },
]

export default ModulesConfig
